module.exports = __webpack_public_path__ + "assets/img/fesBanner-sm.5cd615f6.png";